
import $ from 'jquery';

let $body = $('body');

$body.on('click', '.js-slide-toggle-trigger', function(e) {
    e.preventDefault();

    $('.slide-toggle-item').slideUp('fast');
    $('.js-slide-toggle-trigger').removeClass('slide-toggle-trigger-active');

    let target = $(this).data('slide-toggle-target');

    if($(target+':visible').length === 0) {
        $(target).slideDown('fast');
        $(this).addClass('slide-toggle-trigger-active');
    }
    else {
        $(target).slideUp('fast');
    }
});




if (!$('.search').length) {
    $(document).mouseup(function (e)
    {
        let container = $('.slide-toggle-item');

        if (!container.is(e.target)
            && container.has(e.target).length === 0)
        {
            container.slideUp('fast');
            $('.js-slide-toggle-trigger').removeClass('slide-toggle-trigger-active');

        }
    });
}







